import React from 'react';
import { Autocomplete, Avatar, Box, TextField, Typography } from '@mui/material';
import type { PayerStatRow } from '@store/generated/patient-coverage';

interface PayerFilterProps {
  payers: PayerStatRow[];
  isLoading: boolean;
  value: string;
  onChange: (payerUuid: string, payerName: string) => void;
}

export const PayerFilter: React.FC<PayerFilterProps> = ({ payers, isLoading, value, onChange }) => {
  const selected = payers.find(p => p.payer_uuid === value) ?? null;

  return (
    <Autocomplete<PayerStatRow>
      size="small"
      options={payers}
      loading={isLoading}
      value={selected}
      onChange={(_e, val) => onChange(val?.payer_uuid ?? '', val?.payer_name ?? '')}
      getOptionLabel={opt => opt.payer_name}
      isOptionEqualToValue={(opt, val) => opt.payer_uuid === val.payer_uuid}
      renderOption={(props, opt) => (
        <Box component="li" {...props} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {opt.avatar_url && (
            <Avatar src={opt.avatar_url} sx={{ width: 20, height: 20 }} />
          )}
          <Typography variant="body2" sx={{ fontSize: '0.8125rem' }}>
            {opt.payer_name}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary', ml: 'auto' }}>
            {opt.patient_count}
          </Typography>
        </Box>
      )}
      renderInput={params => (
        <TextField {...params} label="Payer" size="small" placeholder="Search payer..." />
      )}
    />
  );
};
